<!-- <p>create-organisation-report works!</p> -->
<app-dialog-header headerIcon="note_add" headerText="{{existingReport ? 'Edit' : 'Create'}} Summary Report"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
    <div class="main">
        <div class="data-model">
            <div class="tree-container">
                <ejs-treeview #treeviewDialog id="treeviewDialog" [fields]="fields" [allowDragAndDrop]="true"
                    style="width: 100%;" (nodeDragStop)="respondToDrag($event)">
                    <ng-template #nodeTemplate="" let-data="">
                        <div class="treeviewdiv alignRow">
                            <mat-icon style="margin-right: 5px;">
                                {{data.NodeType == "folder" ? "folder"
                                : data.NodeType == "sensor" ? "sensors"
                                : data.NodeType == "datapoint" ? "show_chart"
                                : data.NodeType == "organisation" ? "factory"
                                : "question_mark"}}
                            </mat-icon>
                            <span>{{data.Name}}{{data.Description ? " - " + data.Description : ""}}</span>
                        </div>
                    </ng-template>
                </ejs-treeview>
            </div>
        </div>
        <div class="report-options">
            <div class="included-nodes drag-target">
                <ejs-listview #listviewInstance [dataSource]='includedNodes' [fields]="dataModelNodeFields"
                    cssClass='e-list-template'>
                    <ng-template #template let-data>
                        <div class="ejs-listview-item node-item alignRow">
                            <mat-icon style="margin-right: 5px;">
                                {{data.NodeType == "folder" ? "folder"
                                : data.NodeType == "sensor" ? "sensors"
                                : data.NodeType == "datapoint" ? "show_chart"
                                : data.NodeType == "organisation" ? "factory"
                                : "question_mark"}}
                            </mat-icon>
                            <span>{{data.Name}}</span>
                            <span>{{getNodeChildrenText(data)}}</span>
                            <button mat-icon-button
                                (click)="removeReportItemNode(data)"><mat-icon>close</mat-icon></button>
                        </div>
                    </ng-template>
                </ejs-listview>
                <div class="drag-message" *ngIf="includedNodes.length == 0">Drag a node from the Data Model here to add
                    it
                    to the report.</div>
            </div>
            <div class="options">
                <mat-form-field appearance="fill">
                    <mat-label>Name</mat-label>
                    <input matInput autocomplete="off" formControlName="name">
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>Description</mat-label>
                    <input matInput autocomplete="off" formControlName="description">
                </mat-form-field>
                <div class="interval-type alignRow">
                    <div class="dropdown-container alignRow">
                        <span>Interval: </span>
                        <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='intervals' [fields]="intervalFields"
                            style="margin: auto;" [value]="0" formControlName="interval">
                            <ng-template #itemTemplate let-data>
                                <div>
                                    <span>{{ data.text }}</span>
                                </div>
                            </ng-template>
                        </ejs-dropdownlist>
                    </div>
                    <div class="dropdown-container alignRow">
                        <span>File Type: </span>
                        <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='fileTypes' [fields]="fileTypeFields"
                            style="margin: auto;" [value]="0" formControlName="fileType">
                            <ng-template #itemTemplate let-data>
                                <div>
                                    <span>{{ data.text }}</span>
                                </div>
                            </ng-template>
                        </ejs-dropdownlist>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="dialogForm.value"
            [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
        <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
    </div>
</form>